export default [
  {
    insert: 'AMAZON ',
  },
  {
    insert: '1234567',
  },
  {
    insert: " often complain: It's 下划线:",
  },
  {
    insert: 'so annoying',
    attributes: {
      underline: true,
    },
  },
  {
    insert: ", I don't know",
  },
  {
    insert: 'how to introdu',
    attributes: {},
  },
  {
    insert: 'ce 加粗：',
  },
  {
    insert: 'new products',
    attributes: {
      bold: true,
    },
  },
  {
    insert: ' is 上标: X',
  },
  {
    insert: '2',
    attributes: {
      script: 'sup',
    },
  },
  {
    insert: ' and 下标: Y',
  },
  {
    insert: '3',
    attributes: {
      script: 'sub',
    },
  },
  {
    insert: ', and 斜体: ',
  },
  {
    insert: 'I am stumped',
    attributes: {
      italic: true,
    },
  },
  {
    insert: ' in 图标: ',
  },
  {
    insert: '34',
    attributes: {},
  },
  {
    attributes: {
      DotImgEmbed: {
        id: '255-shp-34',
        value: '1',
      },
    },
    insert: '1',
  },
  {
    insert: '图标: ',
  },
  {
    attributes: {
      DotImgEmbed: {
        id: '255-shp-33',
        value: '33',
      },
    },
    insert: '33',
  },
  {
    insert: ' TITLE, selling 域: ',
  },
  {
    insert: 'points',
    attributes: {},
  },
  {
    insert: " and descriptions, and I can't move a 文字颜色: ",
  },
  {
    insert: 'single',
    attributes: {},
  },
  {
    insert: ' step!',
  },
  {
    attributes: {
      // 标签名待定
      DotFieldEmbed: {
        id: '2-shp-500',
        isOpen: 'true',
        isClose: 'false',
        value: '500',
      },
    },
    insert: ' ',
  },
  {
    insert: '新批注内容',
  },
  {
    attributes: {
      // 标签名待定
      DotFieldEmbed: {
        id: '2-shp-100',
        isOpen: true,
        isClose: false,
      },
    },
    insert: '100',
  },
  {
    insert: '嵌套批注内容',
  },
  {
    attributes: {
      // 标签名待定
      DotFieldEmbed: {
        id: '2-shp-100',
        isOpen: false,
        isClose: true,
      },
    },
    insert: '100',
  },
  {
    insert: '新批注内容',
  },
  {
    attributes: {
      DotFieldEmbed: {
        id: '2-shp-500',
        isOpen: false,
        isClose: true,
      },
    },
    insert: '500',
  },
];
